import {useState} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'

import ModalRejectRequest from './components/modal-confirm-reject-request.js'
import ModalSteps from './components/modal-steps.js'

const noop = () => {}

const ModalTransactionDiscover = ({
  adId = '',
  isSeller = false,
  onModalClose = noop,
  onCtaClick = noop,
  onModalRejectRequestCtaClick = noop,
  onSecondaryCtaClick = noop,
  tradeId
}) => {
  const [showRejectRequestModal, setShowRejectRequestModal] = useState(false)

  if (showRejectRequestModal)
    return (
      <ModalRejectRequest
        onCtaClick={onModalRejectRequestCtaClick}
        onModalClose={() => setShowRejectRequestModal(false)}
        onSecondaryCtaClick={() => setShowRejectRequestModal(false)}
        tradeId={tradeId}
      />
    )

  return (
    <ModalSteps
      adId={adId}
      isSeller={isSeller}
      onCtaClick={onCtaClick}
      onModalClose={onModalClose}
      setShowRejectRequestModal={setShowRejectRequestModal}
    />
  )
}

ModalTransactionDiscover.displayName = 'ModalTransactionDiscover'
ModalTransactionDiscover.propTypes = {
  adId: PropTypes.string,
  isSeller: PropTypes.bool,
  onCtaClick: PropTypes.func,
  onModalClose: PropTypes.func,
  onModalRejectRequestCtaClick: PropTypes.func,
  onSecondaryCtaClick: PropTypes.func,
  tradeId: PropTypes.string
}

export default ModalTransactionDiscover
